import type { Components, Theme } from "@mui/material/styles";
import { darkColors, lightColors } from "../tokens/colors.ts";
import { elevation } from "../tokens/elevation.ts";

export function getMuiCard(mode: "dark" | "light"): Components<Theme>["MuiCard"] {
  const c = mode === "dark" ? darkColors : lightColors;
  return {
    styleOverrides: {
      root: {
        backgroundImage: "none",
        backgroundColor: mode === "dark" ? c.surfaceContainer : c.surfaceContainerLowest,
        border: "none",
        borderRadius: "0.5rem",
        boxShadow: elevation.ghostShadow[mode],
      },
    },
  };
}
